import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import {
    Music,
    Sports,
    Food,
    Nightlife,
    Star, EventMic
} from '../../../assests/ExportImageIcon'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'
import './exploreEvents.css'

// Static fallback — kept for reference / in case GET /customer_events/categories/
// fails. Real categories come from the API below (no icons there, so these
// icons are reused by cycling through them by index).
// const events = [
//     { icon: Music, name: 'Music' },
//     { icon: Sports, name: 'Sports' },
//     { icon: Food, name: 'Food' },
//     { icon: Nightlife, name: 'Nightlife' },
//     { icon: Star, name: 'Star' },
//     { icon: EventMic, name: 'Mic' },
// ]

const CATEGORY_ICONS = [Music, Sports, Food, Nightlife, Star, EventMic]

const ExploreEvents = ({ heading = 'Explore Events', showDestinationDetails = true }) => {
    const navigate = useNavigate()
    const prevRef = useRef(null)
    const nextRef = useRef(null)
    const swiperRef = useRef(null)
    const [categories, setCategories] = useState([])

    useEffect(() => {
        service
            .get(endpoints.customerEvents.categories, {}, { silent: true })
            .then(({ data }) => setCategories(data.data || []))
            .catch(() => {})
    }, [])

    const events = categories.map((category, index) => ({
        id: category.id,
        icon: CATEGORY_ICONS[index % CATEGORY_ICONS.length],
        name: category.name,
    }))

    useEffect(() => {
        const swiper = swiperRef.current
        if (!swiper) return
        swiper.params.navigation = {
            ...swiper.params.navigation,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
        }
        swiper.navigation.init()
        swiper.navigation.update()
    }, [])

    return (
        <>
            <section className='popularDestination paddingCmn'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='secHeadArea'>
                                <div className='mainHead'>{heading}</div>
                                <Link to="/event-list">View All</Link>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="carousel">
                                <Swiper
                                    modules={[Navigation, Autoplay]}
                                    spaceBetween={20}
                                    slidesPerView={1.2}
                                    loop
                                    autoplay={{ delay: 2000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                                    onSwiper={(swiper) => { swiperRef.current = swiper }}
                                    breakpoints={{
                                        576: { slidesPerView: 2 },
                                        768: { slidesPerView: 3 },
                                        992: { slidesPerView: 4 },
                                        1200: { slidesPerView: 5 },
                                    }}
                                >
                                    {events.map((event, index) => (
                                        <SwiperSlide key={event.id ?? index} className="item">
                                            <div className="eventSlide" onClick={() => navigate(`/event-list?category=${event.id}`)}>
                                                <h3 className="eventName">{event.name}</h3>

                                                <div className="eventIconWrapper">
                                                    <div className="greenHalfCircle"></div>

                                                    <img
                                                        src={event.icon}
                                                        alt={event.name}
                                                        className="eventIcon"
                                                    />
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                {/* <button type="button" className="carouselNav carouselNav-prev" ref={prevRef} aria-label="Previous">&#8249;</button>
                                <button type="button" className="carouselNav carouselNav-next" ref={nextRef} aria-label="Next">&#8250;</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ExploreEvents
